import { render, staticRenderFns } from "./UserTopicIndex.vue?vue&type=template&id=414c63c1&"
import script from "./UserTopicIndex.vue?vue&type=script&lang=js&"
export * from "./UserTopicIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports